export default __webpack_public_path__ + "static/logo-266ca0c1488279d3a44cb96121e7af22.png";